import { gql } from '@apollo/client';

export const COPY_SCHEDULE_MUTATION = gql`
  mutation CopySchedule($input: [lessons_insert_input!]!) {
    insert_lessons(objects: $input) {
      affected_rows
    }
  }
`;
